// extracted by mini-css-extract-plugin
export default {"popoverBaseContainer":"InfoPopover_popoverBaseContainer__hCV4M","popoverContainer":"InfoPopover_popoverContainer__HhHzG","popoverText":"InfoPopover_popoverText__-CqpW"};